/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaListColumn from 'DesignSystem/TysiaList/TysiaListColumn/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/Item/Number"
  
}) {
let txCardFieldDefinitionNumberValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'number',
})
  return (<React.Fragment
>
<TysiaListColumn
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 data="tx_card_field_definition.number"
 text={txCardFieldDefinitionNumberValueData}
/>
)}
</TysiaListColumn>
{children}
</React.Fragment>)
}